import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'
import { FormsModule } from '@angular/forms'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { ListboxModule } from 'primeng/listbox'
import { ButtonModule } from 'primeng/button'
import { AssistanceAttachment } from '../../../../models/assistance-attachment.model'

export interface DocumentSelectModalData {
  documents: ReadonlyArray<AssistanceAttachment>
}

/**
 * Dialog for picking existing client documents to be attached to an assistance.
 * Closes with the selected documents (or undefined when dismissed).
 */
@Component({
  selector: 'app-document-select-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, ListboxModule, ButtonModule, TranslocoModule],
  templateUrl: './document-select-modal.component.html',
})
export class DocumentSelectModalComponent {
  private readonly config = inject(DynamicDialogConfig)
  private readonly ref = inject(DynamicDialogRef)

  readonly documents = signal<AssistanceAttachment[]>([...(this.config.data as DocumentSelectModalData).documents])

  selection: AssistanceAttachment[] = []

  confirm(): void {
    this.ref.close(this.selection)
  }
}
